import { render, staticRenderFns } from "./Trafo.vue?vue&type=template&id=ce48e004&"
import script from "./Trafo.vue?vue&type=script&lang=js&"
export * from "./Trafo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports